import React from 'react';
import { FileText } from 'lucide-react';

const Terms = () => {
  return (
    <div className="container py-16" data-testid="terms-page">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#D97706]/10 rounded-full mb-6">
            <FileText className="w-8 h-8 text-[#D97706]" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="terms-title">
            תנאי השימוש באתר
          </h1>
        </div>
        
        <div className="bg-white rounded-2xl p-8 md:p-12 border border-stone-100 space-y-8" data-testid="terms-content">
          
          {/* הקדמה */}
          <section>
            <p className="text-stone-500 text-sm mb-6 text-center">
              תקנון השימוש באתר הנ"ל נכתב בלשון זכר אך האמור בו מתייחס לנשים וגברים כאחד.
            </p>
          </section>
          
          {/* קדימון */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              קדימון
            </h2>
            <p className="text-stone-600 leading-relaxed">
              אתר "בריאות הגבר" (להלן "האתר") הוא אתר המשמש כאתר תוספי תזונה ייצוגי עבור בריאות הגבר והנך מוזמן לקחת בו חלק בכפוף להסכמתך לתנאי השימוש אשר יפורטו להלן. בנוסף השימוש באתר זה על כל תכניו והשירותים המוצעים בו, הורדות של קבצים, מדיה כגון תמונות וסרטונים והתכנים השונים המוצעים לקהל המבקרים עשויים להשתנות מעת לעת או בהתאם לסוג התוכן. הנהלת האתר שומרת לעצמה הזכות לעדכן את תנאי השימוש המוצגים להלן מעת לעת וללא התראה או אזכור מיוחד בערוצי האתר השונים.
            </p>
          </section>
          
          {/* קניין רוחני */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              קניין רוחני
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              האתר כמו גם כל המידע שבו לרבות עיצוב האתר, קוד האתר, קבצי מדיה לרבות גרפיקות, סרטונים, תמונות, טקסטים, קבצים המוצעים להורדה וכל חומר אחר אשר מוצג באתר שייכים במלואם להחנות של בריאות הגבר ומהווים קניין רוחני בלעדי של האתר ואין לעשות בהם שימוש ללא אישור כתוב מראש מאתר בריאות הגבר.
            </p>
            <p className="text-stone-600 leading-relaxed">
              בנוסף אין להפיץ, להעתיק, לשכפל, לפרסם, לחקות או לעבד פיסות קוד, גרפיקות, סרטונים, סימנים מסחריים או כל מדיה ותוכן אחר מבלי שיש ברשותכם אישור כתוב מראש מבעלי האתר או מישהו מטעמו.
            </p>
          </section>
          
          {/* תוכן האתר */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              תוכן האתר
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              אנו שואפים לספק לכם את המידע המוצג באתר ללא הפרעות אך יתכנו בשל שיקולים טכניים, תקלות צד ג או אחרים, הפרעות בזמינות האתר. ולכן איננו יכולים להתחייב כי האתר יהיה זמין לכם בכל עת ולא יינתן כל פיצוי כספי או אחר בשל הפסקת השירות / הורדת האתר.
            </p>
            <p className="text-stone-600 leading-relaxed">
              קישורים לאתר חיצוניים אינם מהווים ערובה כי מדובר באתרים בטוחים, איכותיים או אמינים וביקור בהם נעשה על דעתכם האישית בלבד ונמצאים בתחום האחריות הבלעדי של המשתמש באתר. התכנים המוצעים באתר הינם בבעלותם הבלעדית של החנות של בריאות הגבר ואין לעשות בהם שימוש אשר נוגד את האמור בתקנון זה למעט במקרים בהם צוין אחרת או במקרים בהם צוין כי זכויות היוצרים שייכים לגוף חיצוני.
            </p>
          </section>
          
          {/* ניהול משתמשים */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              ניהול משתמשים ומבקרים באתר
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              הנהלת האתר שומרת לעצמה את הזכות לחסום כל משתמש ובין אם על ידי חסימת כתובת הIP של המחשב שלו, כתובת הMACID של המחשב שלו או אפילו בהתאם למדינת המוצא ללא צורך לספק תירוץ אשר מקובל על הגולש.
            </p>
            <p className="text-stone-600 leading-relaxed">
              צוות האתר / הנהלת האתר יעשה כל שביכולתו להגן על פרטי המשתמשים הרשומים באתר / מנויים הרשומים באתר. במקרים בהם יעלה בידיו של צד שלישי להשיג גישה למידע מוסכם בזאת כי לגולשים, משתמשים וחברים באתר לא תהה כל תביעה, טענה או דרישה כלפי צוות האתר "בריאות הגבר".
            </p>
          </section>
          
          {/* גילוי נאות */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              גילוי נאות
            </h2>
            <p className="text-stone-600 leading-relaxed">
              באתר זה עשוי לעשות שימוש בקבצי קוקיז (במיוחד עבור משתמשים רשומים ומנויים) ובממשקי סטטיסטיקה פנימיים בכדי לשמור תיעוד סטטיסטי אנונימי של גולשים וניתוח תנועת הגולש/ים, הרגלי גלישה באתר וניתוח קליקים וזמן שהייה. בכל העת ולבד מאשר גולשים המחוברים לאתר המידע הנשמר הוא אנונימי לחלוטין ואין בו את שם הגולש או כל פרט מזהה אחר.
            </p>
          </section>
          
          {/* אחריות המוצר */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              אחריות המוצר
            </h2>
            <p className="text-stone-600 leading-relaxed">
              אנו בריאות הגבר עושים את המיטב ועובדים באופן ישיר עם כל גופי אכיפת החוק במדינת ישראל. המוצרים מיוצרים במפעל תחת פיקוח משרד הבריאות וכל האישורים הדרושים לקח. המוצר מיוצר מחומרי גלם הטובים בשוק. אנו עושים את המיטב ללא פשרות ושואפים להיות הטובים בשוק בתחום שיפור חיי המין לגבר בדרך טבעית. המוצר יעיל ומסייע משפר את חיי המין של הגבר. עם זאת, קורה שהשפעתו אינה מגיבה במהירות ואופן השפעתו לוקחת זמן מהממוצע. ואף מכרים גם לא מקבל תוצאות לשביעות רצון הלקוח. זה אינדיבידואלי ואין לנו שליטה בדבר. מה שמצביע על מצב הלקוח שישנה בעיה יותר חמורה ואף קלינית.
            </p>
          </section>
          
          {/* אזור שיפוט */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              אזור שיפוט
            </h2>
            <p className="text-stone-600 leading-relaxed">
              בעת שאתם עושים שימוש באתר ובמקרה בו התגלה כל מחולקת אתם מסכימים להלן כי האמור לעיל נמצא תחת סמכות השיפוט הבלעדי של החוק הישראלי תוך שימוש במערכת בתי המשפט הישראליים בלבד במחוז תל אביב.
            </p>
          </section>
          
          {/* כשרות המוצרים */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              כשרות המוצרים
            </h2>
            <p className="text-stone-600 leading-relaxed">
              התוספים המוצעים למכירה באתר הם כשרות בד"ץ מהדרין, עם זאת אנו בודקים את התכולה של כל תוסף ללא יוצא מן הכלל כדי לוודא שאין בו חומרים האסורים על פי ההלכה, אם מצאתם תוסף שנמצא מכיל חומרים האסורים על פי ההלכה בבקשה דווחו לנו עליו ואנו נסיר אותו לאלתר.
            </p>
          </section>
          
          {/* משלוחים */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              משלוחים
            </h2>
            <p className="text-stone-600 leading-relaxed">
              במידה והפריט שהוזמן מתעכב עקב זה שהלקוח מסר כתובת לא תקנית או שהפריט עוכב אצל גורמים שאינם קשורים לחברת השילוח יהיה עליו לדאוג לשחרור הפריט מהגורם המעכב. חשוב לזכור למשלמים במזומן, אנחנו משלמים מראש עבורכם לחברת המשלוחים ואם תסרבו לקבל את המשלוח או לא תענו לשליח בטלפון או בהודעות תחוייבו בדמי המשלוח על סך 59₪ אותו תידרשו לשלם בתוך 30 יום, סכום זה ילך ויכפיל את עצמו כל 30 יום עד רגע התשלום ועלול לגרור הליך משפטי. אנא הימנעו מאי נעימות.
            </p>
          </section>
          
          {/* החזרת מוצרים */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              החזרת מוצרים
            </h2>
            <p className="text-stone-600 leading-relaxed">
              לא ניתן להחזיר מוצרים כגון תרופות ותוספי תזונה. גם אם הם סגורים לחלוטין. אם ההזמנה\המשלוח יצא לדרכו, יש לשלם דמי ביטול שהם 5% מגובה המוצר או 100 ש"ח ועוד דמי המשלוח הנעים בין 49 ש"ח עד 79 ש"ח (תלוי באופי המשלוח).
            </p>
          </section>
          
          {/* זכויות קניין רוחני */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              זכויות קניין רוחני
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              כל הזכויות שמורות. כולל אך לא רק:
            </p>
            <ul className="list-disc list-inside text-stone-600 space-y-2 mr-6">
              <li>אין לעשות שימוש פומבי או מסחרי כלשהו בתכני האתר הכוללים מלל, HTML, מצגות, גרפיקה וכן חומר מוצג של צד שלישי.</li>
              <li>אין להעתיק, לתקצר, לשכפל, לפרסם, להוציא לאור, לשנות, למכור, להפיץ, או להציג את תכני האתר.</li>
            </ul>
          </section>
          
          {/* היתר מוגבל */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              היתר מוגבל
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              הנהלת האתר מעניקה היתר מוגבל להציג על מחשב אישי, להדפיס, להוריד ולהשתמש במידע וזאת למטרות שימוש פרטי פנימי, לימודי, לא-מסחרי בלבד, בפרט שישמרו התנאים הבאים:
            </p>
            <ul className="list-disc list-inside text-stone-600 space-y-2 mr-6">
              <li>לא יעשה שינוי של המידע; ישמרו כל הזכויות השמורות והבחנות קנייניות אחרות; כולל ציון מקור המידע.</li>
              <li>אין להשתמש בכל מידע למטרות מסחריות או לכל הצגה פומבית (מסחרית או לא מסחרית).</li>
              <li>כולל כל מידע או אזכור בתוך כל מידע, מוצר או שרות שהנך יוצר, מפיץ או מספק.</li>
              <li>כולל העתקה או העברה של כל מידע לתוך אתר אינטרנט שלך או כל אתר אינטרנט או שרת.</li>
            </ul>
          </section>
          
          {/* הבהרה רפואית */}
          <section className="bg-amber-50 rounded-xl p-6 border border-amber-200">
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              הבהרה חשובה
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              התכנים שבאתר אינם מהווים תחליף לאבחון וייעוץ מקצועי. המידע המופיע באתר מיועד להרחבת הידע האישי וההבנה בנושא תחזוקת ושיפור חיי המין והזוגיות.
            </p>
            <p className="text-stone-600 leading-relaxed">
              אולם המידע אינו מתיימר להיות ואינו מהווה תחליף לאבחון או טיפול, להנחיה רפואית, חוות דעת רפואית, או תחליף להתייעצות עם רופא מומחה. אין להשתמש במידע המופיע באתר לצורך אבחון או טיפול בבעיות בריאותיות. המידע באתר הינו כללי מטבעו ואינו ספציפי.
            </p>
          </section>
          
          {/* גבולות האחריות */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              גבולות האחריות
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              המידע התכנים והשירותים המופיעים באתר ניתנים "כמות שהם" (as is) ו/או "כפי זמינותם" (as available) וללא אחריות מכל סוג שהוא בנוגע לאתר או למידע המופיע בו.
            </p>
            <p className="text-stone-600 leading-relaxed mb-4">
              האתר יעשה כל מאמץ על מנת לספק מידע מדויק, למרות זאת האתר מתנער בזאת מכל אחריות מפורשת ו/או מכללא לגבי השימוש באתר, לרבות כל אחריות בנוגע לאיכות, דייקנות, שלמות, עדכניות או התאמה למטרה ספציפית של המידע באתר או של כל מוצר או שרות המוזכרים באתר.
            </p>
            <p className="text-stone-600 leading-relaxed">
              לא תהיה למשתמשים כל תביעה, דרישה או טענה, מכל סוג שהוא כלפי האתר ו/או המרכז ו/או בעליו של האתר ו/או כלפי צוות היועצים, העורכים והכותבים המשתתפים בעריכתו.
            </p>
          </section>
          
          {/* קישורים */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              קישורים
            </h2>
            <p className="text-stone-600 leading-relaxed">
              אתר זה עשוי להכיל קישורים לאתרי אינטרנט אחרים. המרכז אינו אחראי לתכנים של אתרים מקושרים אלו ולא אחראי לנכונות או להתאמה של המידע המופיע באתרים אלו. הכללה של הקישורים באתר אינו מצביע על תמיכה של האתר באתרים המקושרים. השימוש בקישורים הינו באחריות המשתמש.
            </p>
          </section>
          
          {/* שמירה על פרטיות */}
          <section>
            <h2 className="text-2xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
              שמירה על פרטיות המשתמש
            </h2>
            <p className="text-stone-600 leading-relaxed mb-4">
              אתר "בריאות הגבר" מתחייב בזאת לשמור על פרטיותכם. כל מידע אישי אשר ישלח אלינו באמצעות טופס "צור קשר" יישאר חסוי. לעולם לא נשתמש בדואר האלקטרוני שלכם חוץ מאשר לשלוח אליכם את הניוזלטר שלנו או להשיב על שאלותיכם שנשלחו אלינו באמצעות טופס "צור קשר".
            </p>
            <p className="text-stone-600 leading-relaxed">
              זכותכם בכל עת להסיר את פרטיכם מרשימת התפוצה של האתר באמצעות לחיצה על הקישור "הסרה מרשימת התפוצה" שיופיע בעת קבלת הניוזלטר בדואר האלקטרוני.
            </p>
          </section>
          
          {/* סמכות שיפוט */}
          <section className="bg-stone-50 rounded-xl p-6 border border-stone-200">
            <p className="text-stone-600 leading-relaxed text-center font-medium">
              הסכם זה כפוף לדיני מדינת ישראל. הנכם מסכימים בזאת כי לבתי המשפט בתל-אביב-יפו תהיה סמכות השיפוט הבלעדית.
            </p>
          </section>
          
        </div>
      </div>
    </div>
  );
};

export default Terms;
